import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
export const headingStructureAILoadingPageIdAtom = atom(null);
export const headingStructureAIAtomFamily = atomFamily(_pageId => atom({
  generatedElements: new Map(),
  hasAppliedAiFixes: false,
  isCancelled: false,
  isLoading: false,
  result: null,
  snapshot: null
}));
export const headingStructureAIPagesWithResultAtom = atom(new Set());
export const resetAllHeadingStructureAIAtom = atom(null, (get, set) => {
  const pagesWithResult = get(headingStructureAIPagesWithResultAtom);
  for (const pageId of pagesWithResult) {
    set(headingStructureAIAtomFamily(pageId), {
      generatedElements: new Map(),
      hasAppliedAiFixes: false,
      isCancelled: false,
      isLoading: false,
      result: null,
      snapshot: null
    });
  }
  headingStructureAIAtomFamily.setShouldRemove(() => true);
  headingStructureAIAtomFamily.setShouldRemove(null);
  set(headingStructureAILoadingPageIdAtom, null);
  set(headingStructureAIPagesWithResultAtom, new Set());
});
export const cancelHeadingStructureAIAtom = atom(null, (_get, set, pageId) => {
  set(headingStructureAILoadingPageIdAtom, null);
  set(headingStructureAIAtomFamily(pageId), s => ({
    ...s,
    generatedElements: new Map(),
    hasAppliedAiFixes: false,
    isCancelled: true,
    isLoading: false,
    result: null,
    snapshot: null
  }));
  set(headingStructureAIPagesWithResultAtom, prev => {
    if (!prev.has(pageId)) {
      return prev;
    }
    const next = new Set(prev);
    next.delete(pageId);
    return next;
  });
});
//# sourceMappingURL=heading-structure-ai-atoms.js.map